import { UserList } from '../../../components/User';
import { UserType } from '../../../types';

export function MemberUsers() {
  return <UserList type={UserType.Member} hasLastVerified />;
}
